export default "__VITE_ASSET__CG$6X5G3__"